// import { getInicisData } from "src/service/pay";

export const insertInicisModule = async () => {
  const inicisScript = document.createElement("script");
  inicisScript.id = "inicisScript";
  const inicisCloseScript = document.createElement("script");
  inicisCloseScript.id = "inicisCloseScript";
  if (window.location.hostname === "cloudportal.fasoo.com") {
    inicisScript.src = "https://stdpay.inicis.com/stdjs/INIStdPay.js";
    inicisCloseScript.src =
      "https://stdpay.inicis.com/stdjs/INIStdPay_close.js";
  } else {
    inicisScript.src = "https://stgstdpay.inicis.com/stdjs/INIStdPay.js";
    inicisCloseScript.src =
      "https://stgstdpay.inicis.com/stdjs/INIStdPay_close.js";
  }
  inicisScript.async = true;
  inicisCloseScript.async = true;

  if (!document.getElementById("inicisScript")) {
    document.head.appendChild(inicisScript);
  }
  if (!document.getElementById("inicisCloseScript")) {
    document.head.appendChild(inicisCloseScript);
  }

  // let inicisData;

  // if (
  //   window.portal.customUserId === this.commonStore.userInfo.userInfo.userId
  // ) {
  //   inicisData = await getInicisData(
  //     window.portal.customUserPrice
  //   );
  // }
};
